<div class="ms-tabs">
    <ng-content></ng-content>
</div>
